import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD_uyJWPaGVhXOtARFVmn79s7mrINroFzA",
  authDomain: "vortex-af85f.firebaseapp.com",
  databaseURL: "https://vortex-af85f-default-rtdb.firebaseio.com",
  projectId: "vortex-af85f",
  storageBucket: "vortex-af85f.firebasestorage.app",
  messagingSenderId: "638854039132",
  appId: "1:638854039132:web:c0d450834f75a5d6630899",
  measurementId: "G-86VT11NSWV"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

const authReady = new Promise((resolve) => {
  const unsub = onAuthStateChanged(auth, (user) => {
    unsub();
    resolve(user);
  });
});

let loginPromise = null;


export function loginAdmin() {
  if (!loginPromise) {
    loginPromise = (async () => {
      const existing = await authReady;
      if (existing || auth.currentUser) return auth.currentUser;
      const cred = await signInWithEmailAndPassword(auth, "vortex@gmail.com", "Allahloveu12@");
      return cred.user;
    })().catch((e) => {
      loginPromise = null;
      throw e;
    });
  }
  return loginPromise;
}